export default __webpack_public_path__ + "static/media/products_414.15030c7f.jpg";